import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findEngineeringGuarantee = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-guarantee?` + params,
        method: 'GET'
    })
}
export const findEngineeringProjectAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-project/all`,
        method: 'GET'
    })
}
export const findEngineeringDynamicId = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-guarantee/${id}`,
        method: 'GET'
    })
}
export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
        method: 'GET'
    })
}
export const addEngineeringGuarantee = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-guarantee`,
        method: 'POST',
        data: params
    })
}

export const findEngineeringGuaranteeDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-guarantee/${id}`,
        method: 'GET'
    })
}
export const editEngineeringGuarantee = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-guarantee`,
        method: 'PUT',
        data: params
    })
}

export const delItem = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v2/engineering-guarantee/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}






export const findProject = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/project/select?` + params,
        method: 'GET'
    })
}